export default function (testValue, inputValue) {
	if (!testValue || inputValue === null) {
		return false;
	}

	let test = parseFloat(testValue);
	let value = parseFloat(inputValue);

	let margin = 1.6;
	let difference = Math.abs(test - value).toFixed(4);

	return difference <= margin;
}